/**
 * API client for Peter Bot
 */
class BotApi {
  constructor(apiUrl) {
    this.apiUrl = apiUrl || process.env.REACT_APP_PETER_BOT_API_URL || 'http://localhost:5002';
  }

  /**
   * Get conversation
   */
  async getConversation(conversationId, token) {
    const response = await fetch(`${this.apiUrl}/api/chat/${conversationId}?token=${token}`);
    if (!response.ok) {
      throw new Error(`Failed to get conversation: ${response.statusText}`);
    }
    return response.json();
  }

  /**
   * Send message
   */
  async sendMessage(conversationId, token, message) {
    const response = await fetch(`${this.apiUrl}/api/chat/${conversationId}/message?token=${token}`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({ message })
    });

    if (!response.ok) {
      throw new Error(`Failed to send message: ${response.statusText}`);
    }
    return response.json();
  }

  /**
   * Get conversation status
   */
  async getStatus(conversationId, token) {
    const response = await fetch(`${this.apiUrl}/api/chat/${conversationId}/status?token=${token}`);
    if (!response.ok) {
      throw new Error(`Failed to get status: ${response.statusText}`);
    }
    return response.json();
  }
}

export default BotApi;

